import { useEffect } from "react";
import { IMAGES } from "../../../../assets";

const OfferVideo = () => {
  return (
    <div className="offer-videosection">
      <div className="container">
        <div className="row position-relative">
          <div className="col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="position-relative">
              {/* <a
                className="popup-vimeo"
                href="https://youtu.be/Z3euZqj3Ocg?si=4SyJfuBqxtHaP2_s"
              > */}
                <figure className="mb-0 vediosession">
                  {/* <img
                    className="thumb img-fluid"
                    style={{ cursor: "pointer" }}
                    src={IMAGES.image_videosession}
                    alt=""
                  /> */}
                  <video width="100%" controls autoPlay muted style={{ borderRadius: "30px" }}>
                    <source src={IMAGES.video} type="video/mp4" />
                    <source src="movie.ogg" type="video/ogg" />
                    Your browser does not support the video tag.
                  </video>
                </figure>
              {/* </a> */}
            </div>
          </div>
          <figure className="mb-0 image-sidecircle">
            <img className="img-fluid" src={IMAGES.image_sidecircle} alt="" />
          </figure>
        </div>
      </div>
    </div>
  );
};

export default OfferVideo;
